import React, { Component } from 'react'
import { Button, Popover, OverlayTrigger } from 'react-bootstrap'
import { ShareButtons, generateShareIcon } from 'react-share'
import { Link } from 'react-router'
import { translate } from 'react-translate'

@translate('Propiedad')
class Header extends Component{

  render() {

    const { property, t } = this.props

    //box of operation type class
    let classes = (property.operation_type.name === 'Alquiler')
      ? 'propiedad-tipo' + ' ' + 'rent' : 'propiedad-tipo' + ' ' + 'sale'
    if (property.operation_type.name == 'Alquiler temporario' ){
      classes = 'propiedad-tipo' + ' ' + 'rent rent-temp'
    }

    let location = property.short_address

    let dir = property.address.toLowerCase().replace(/([^a-z])([a-z])(?=[a-z]{2})|^([a-z])/g, function(_, g1, g2, g3) {
      return (typeof g1 === 'undefined') ? g3.toUpperCase() : g1 + g2.toUpperCase() } )

    let prop_title = property.property_type.name + ' en ' + property.operation_type.name + ' en ' + dir + ' '
    let divisa_rental = property.rental_currency.name
    let divisa_sale = property.sale_currency.name
    if (property.rental_currency.name == 'Dolar') {
      divisa_rental = 'u$s'
    }
    if (property.sale_currency.name == 'Dolar') {
      divisa_sale = 'u$s'
    }
    let amount = (property.operation_type.name === 'Alquiler' || property.operation_type.name == 'Alquiler temporario') ? divisa_rental + ' ' + (parseInt(property.rental_amount)).toLocaleString('de-DE') : divisa_sale + ' ' + (parseInt(property.sale_amount)).toLocaleString('de-DE')

    // let amount = (property.operation_type.name === 'Alquiler' || property.operation_type.name == "Alquiler temporario") ? property.rental_currency.name + ' ' + (parseInt(property.rental_amount)).toLocaleString('de-DE'): property.sale_currency.name + ' ' + (parseInt(property.sale_amount)).toLocaleString('de-DE')
    let price

    if((property.category_type_id === 9 || !property.web_price) ||
      ((property.operation_type.name == 'Alquiler' || property.operation_type.name == 'Alquiler temporario') && (property.rental_amount in [0, 1, null, undefined, ''])) ||
      (property.operation_type.name == 'Venta' && (property.sale_amount in [0, 1, null, undefined, '']))) {
      price = t('Consultar_precio')
    } else {
      price = amount
    }
    let priceClass = (property.category_type_id === 13 || property.category_type_id === 9 || !property.web_price) ? 'no-price-box' : 'price-box'

    let categoryName = ''

    if (property.is_venture === 'true') {
      categoryName = 'emprendimientos'
    } else {
      if (property.property_type.id === 6 || property.property_type.id === 500000000000034) {
        categoryName = 'terrenos'
      } else {
        switch(property.category_type_id) {
          case 3:
            categoryName = 'locales'
            break
          case 6:
            categoryName = 'residencial'
            break
          default:
            categoryName = property.category_type_name
        }
      }
    }

    categoryName = categoryName ? categoryName.charAt(0).toUpperCase() + categoryName.slice(1) : ''

    if((property.category_type_id === 9 || !property.web_price) ||
      ((property.operation_type.name == 'Alquiler' || property.operation_type.name == 'Alquiler temporario') && (property.rental_amount in [0, 1, null, undefined, ''])) ||
      ((property.operation_type.name == 'Venta' || property.operation_type.name == 'Venta/Alquiler') && (property.sale_amount in [0, 1, null, undefined, '']))) {
      price = t('Consultar_precio')
      priceClass = 'no-price-box'
    } else {
      price = amount
    }

    let boxOperations = ''

    if (property.operation_type.name == 'Venta/Alquiler'){
      boxOperations = (
        <div className='info-left'>
          <h1> {prop_title} </h1>
          <div className='propiedad-tipo sale'>
            {t('Venta')}
          </div>
          <div className='propiedad-tipo rent'>
            {t('Alquiler')}
          </div>
        </div>
      )
    }
    else{
      boxOperations = (
        <div className='info-left'>
          <h1> {prop_title} </h1>
          <div className={classes}>
            {t(property.operation_type.name)}
          </div>
        </div>
      )
    }

    //Social Share

    let baseUrl = window.location.origin
    let shareUrl = baseUrl + '/' + property.uri
    let adminAreaUrl = baseUrl + '/propiedades?q=' + JSON.stringify({
      order_by: 'max_price',
      administrative_areas: [property.neighborhood.administrative_area_id],
      page:1
    })
    let categoryUrl = baseUrl + '/' + categoryName.toLowerCase()

    const { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } = ShareButtons

    const FacebookIcon = generateShareIcon('facebook')
    const TwitterIcon = generateShareIcon('twitter')
    const LinkedinIcon = generateShareIcon('linkedin')
    const WhatsappIcon = generateShareIcon('whatsapp')
    const title = 'LJ Ramos'

    const popoverShare = (
      <Popover id='popover-share'>
        <WhatsappShareButton
          url={shareUrl}
          title={title}>
          <WhatsappIcon
            size={20}
            round={false} />
        </WhatsappShareButton>
        <FacebookShareButton
          url={shareUrl}
          title={title}>
          <FacebookIcon
            size={20}
            round={false} />
        </FacebookShareButton>
        <TwitterShareButton
          url={shareUrl}
          title={title}>
          <TwitterIcon
            size={20} />
        </TwitterShareButton>
        <LinkedinShareButton
          url={shareUrl}
          title={title}>
          <LinkedinIcon
            size={20} />
        </LinkedinShareButton>
      </Popover>
    )
    return (
      <div className='info-content hidden-xs'>
        <div className='col-md-6 col-sm-6 col-left'>
          <ol className='route-info hidden-xs' itemScope itemType='http://schema.org/BreadcrumbList'>
            <li itemProp='itemListElement' itemScope itemType='http://schema.org/ListItem'>
              <a href={ categoryUrl } itemProp='item' itemType='http://schema.org/Thing'>
                <span itemProp='name'><small>{ categoryName }</small></span>
                <meta itemProp='position' content='1' />
              </a>
            </li>

            <i className='fa fa-angle-right'></i>

            <li itemProp='itemListElement' itemScope itemType='http://schema.org/ListItem'>
              <a href={ adminAreaUrl } itemProp='item' itemType='http://schema.org/Thing'>
                <span itemProp='name'><small>{ location }</small></span>
                <meta itemProp='position' content='2' />
              </a>
            </li>

            <i className='fa fa-angle-right'></i>

            <li itemProp='itemListElement' itemScope itemType='http://schema.org/ListItem'>
              <Link to={ shareUrl } itemProp='item' itemType='http://schema.org/Thing'>
                <span itemProp='name'><small>{ prop_title }</small></span>
                <meta itemProp='position' content='3' />
              </Link>
            </li>
          </ol>

          {boxOperations}
          <div className='info-right'>
            <i className='fa fa-map-marker fa-lg'></i>
            <h2 className='location'>{location}</h2>
          </div>
        </div>
        <div className='col-md-6 col-sm-6 col-right'>
          <div className='wrapper-info'>
            <div className='box-buttons'>
              <OverlayTrigger trigger='click' rootClose placement='top' overlay={popoverShare}>
                <Button>
                  <i className='fa fa-share-alt fa-lg'></i>
                </Button>
              </OverlayTrigger>
            </div>
            <p className={priceClass}>{price}</p>
            <p> {t('Codigo')}: {property.property_code}</p>
          </div>
        </div>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/Detail/header.js